<div class="modal fade" id="kt_modal_vendor_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Vendor' : 'Add Vendor' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="vendorForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Company Name -->
            <div class="col-md-4 mb-5">
              <label class="form-label required">Company Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="company_name"
                placeholder="Enter company name"
                [class.is-invalid]="company_name?.invalid && company_name?.touched"
              />
              <div *ngIf="company_name?.invalid && company_name?.touched" class="invalid-feedback">
                <div *ngIf="company_name?.errors?.['required']">Company name is required</div>
                <div *ngIf="company_name?.errors?.['minlength']">Company name must be at least 2 characters</div>
              </div>
            </div>

            <!-- Address Line 1 -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Address Line 1</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="address_line_1"
                placeholder="Enter address line 1"
              />
            </div>

            <!-- Vendor Type -->
            <div class="col-md-4 mb-5">
              <label class="form-label required">Vendor Type</label>
              <div class="dropdown w-100">
                <button
                  class="btn btn-outline-secondary dropdown-toggle w-100 text-start d-flex justify-content-between align-items-center"
                  [class.border-danger]="vendor_type?.invalid && vendor_type?.touched"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <span *ngIf="!hasSelectedVendorTypes" class="text-muted">Select vendor types...</span>
                  <span *ngIf="hasSelectedVendorTypes">
                    {{ selectedVendorTypesCount }} type(s) selected
                  </span>
                </button>
                <ul class="dropdown-menu w-100" style="max-height: 250px; overflow-y: auto;">
                  <!-- Select All / Clear All Options -->
                  <li class="dropdown-item-text px-3 py-2 border-bottom" (click)="$event.stopPropagation()">
                    <div class="d-flex justify-content-between">
                      <button type="button" class="btn btn-sm btn-light-primary" (click)="selectAllVendorTypes()">
                        Select All
                      </button>
                      <button type="button" class="btn btn-sm btn-light-danger" (click)="clearAllVendorTypes()">
                        Clear All
                      </button>
                    </div>
                  </li>
                  <!-- Vendor Type Options -->
                  <li *ngFor="let type of vendorTypes" class="dropdown-item-text px-3 py-2" (click)="$event.stopPropagation()">
                    <div class="form-check mb-0">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [id]="'vendor_type_' + type.value"
                        [checked]="isVendorTypeSelected(type.value)"
                        (change)="toggleVendorType(type.value)"
                        (click)="$event.stopPropagation()">
                      <label class="form-check-label w-100 cursor-pointer" [for]="'vendor_type_' + type.value">
                        {{ type.label }}
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
              <div *ngIf="vendor_type?.invalid && vendor_type?.touched" class="text-danger mt-1">
                <small *ngIf="vendor_type?.errors?.['required']">At least one vendor type is required</small>
              </div>
              <!-- Display selected types as badges -->
              <div *ngIf="hasSelectedVendorTypes" class="mt-2">
                <span *ngFor="let selectedType of vendor_type?.value" class="badge badge-light-primary me-1 mb-1">
                  {{ getVendorTypeLabel(selectedType) }}
                  <i class="ki-duotone ki-cross fs-2qx ms-1 cursor-pointer" (click)="toggleVendorType(selectedType)">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>
              </div>
            </div>

            <!-- City -->
            <div class="col-md-4 mb-5">
              <label class="form-label">City</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="city"
                placeholder="Enter city"
              />
            </div>

            <!-- State -->
            <div class="col-md-4 mb-5">
              <label class="form-label">State</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="state"
                placeholder="Enter state"
              />
            </div>

            <!-- Address Line 2 -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Address Line 2</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="address_line_2"
                placeholder="Enter address line 2"
              />
            </div>

            <!-- Zip Code -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Zip Code</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="zip_code"
                placeholder="Enter zip code"
              />
            </div>

            <!-- Email 1 -->
            <div class="col-md-4 mb-5">
              <label class="form-label required">Email 1</label>
              <input
                type="email"
                class="form-control form-control-solid"
                formControlName="email_1"
                placeholder="Enter email address"
                [class.is-invalid]="email_1?.invalid && email_1?.touched"
              />
              <div *ngIf="email_1?.invalid && email_1?.touched" class="invalid-feedback">
                <div *ngIf="email_1?.errors?.['required']">Email is required</div>
                <div *ngIf="email_1?.errors?.['email']">Please enter a valid email address</div>
              </div>
            </div>

            <!-- Email 2 -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Email 2</label>
              <input
                type="email"
                class="form-control form-control-solid"
                formControlName="email_2"
                placeholder="Enter email address"
                [class.is-invalid]="email_2?.invalid && email_2?.touched"
              />
              <div *ngIf="email_2?.invalid && email_2?.touched" class="invalid-feedback">
                <div *ngIf="email_2?.errors?.['email']">Please enter a valid email address</div>
              </div>
            </div>

            <!-- Country -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Country</label>
              <select
                class="form-select form-select-solid"
                formControlName="country"
              >
                <option value="">Select country</option>
                <option *ngFor="let country of countryList" [value]="country.name">{{ country.name }}</option>
              </select>
            </div>

            <!-- Email 3 -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Email 3</label>
              <input
                type="email"
                class="form-control form-control-solid"
                formControlName="email_3"
                placeholder="Enter email address"
                [class.is-invalid]="email_3?.invalid && email_3?.touched"
              />
              <div *ngIf="email_3?.invalid && email_3?.touched" class="invalid-feedback">
                <div *ngIf="email_3?.errors?.['email']">Please enter a valid email address</div>
              </div>
            </div>

            <!-- Contact -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Contact</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="contact"
                placeholder="Enter contact person"
              />
            </div>

            <!-- Post -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Post</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="post"
                placeholder="Enter post"
              />
            </div>

            <!-- Mobile -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Mobile</label>
              <input
                type="tel"
                class="form-control form-control-solid"
                formControlName="mobile"
                placeholder="Enter mobile number"
              />
            </div>

            <!-- Tel -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Tel</label>
              <input
                type="tel"
                class="form-control form-control-solid"
                formControlName="tel"
                placeholder="Enter telephone number"
              />
            </div>

            <!-- Fax No -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Fax No</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="fax_no"
                placeholder="Enter fax number"
              />
            </div>

            <!-- Opening Bal -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Opening Bal</label>
              <input
                type="number"
                class="form-control form-control-solid"
                formControlName="opening_bal"
                placeholder="Enter opening balance"
                step="0.01"
              />
            </div>

            <!-- Opening Bal Date -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Opening Bal Date</label>
              <input
                type="date"
                class="form-control form-control-solid"
                formControlName="opening_bal_date"
              />
            </div>

            <!-- POS No -->
            <div class="col-md-4 mb-5">
              <label class="form-label">POS No.</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="pos_no"
                placeholder="Enter POS number"
              />
            </div>

            <!-- Type -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Type</label>
              <div class="d-flex gap-3 mt-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="type"
                    value="debit"
                    id="type_debit"
                  />
                  <label class="form-check-label" for="type_debit">
                    Debit
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="type"
                    value="credit"
                    id="type_credit"
                  />
                  <label class="form-check-label" for="type_credit">
                    Credit
                  </label>
                </div>
              </div>
            </div>

            <!-- Company Tax Code -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Company Tax Code</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="company_tax_code"
                placeholder="Enter company tax code"
              />
            </div>

            <!-- Custom Clearance -->
            <div class="col-md-4 mb-5">
              <label class="form-label">Custom Clearance</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="custom_clearance"
                placeholder="Enter custom clearance"
              />
            </div>

            <!-- File Upload -->
            <div class="col-md-8 mb-5">
              <label class="form-label">Document</label>
              <div class="d-flex align-items-center gap-3">
                <input
                  type="file"
                  class="form-control form-control-solid"
                  id="document"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  (change)="onFileSelected($event)"
                  [disabled]="fileUploaded"
                />
                <div *ngIf="fileUploaded" class="d-flex align-items-center">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  <span class="text-muted">Uploading...</span>
                </div>
                <button
                  *ngIf="uploadedFileUrl && !fileUploaded"
                  type="button"
                  class="btn btn-sm btn-light-danger"
                  (click)="removeFile()">
                  Remove
                </button>
              </div>
              <div class="form-text">Allowed file types: pdf, doc, docx, jpg, jpeg, png</div>
              <div *ngIf="uploadedFileUrl && !fileUploaded" class="mt-2">
                <small class="text-success">
                  <i class="ki-duotone ki-check fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                  File uploaded successfully
                </small>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update Vendor' : 'Add Vendor' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
